import { OnboardingService } from "@/shared/api/services";

export async function getCustomerId() {
  let resolvedCustomerId: string | number | null = null;

  // 1) Query param has highest precedence
  const searchParams = new URLSearchParams(window.location.search);
  const qpCustomerId = searchParams.get("customerId");
  if (qpCustomerId) resolvedCustomerId = qpCustomerId;

  // 2) Local customer snapshot
  if (!resolvedCustomerId) {
    try {
      const storedCustomerRaw =
        typeof window !== "undefined"
          ? localStorage.getItem("customerData")
          : null;
      const storedCustomer = storedCustomerRaw
        ? JSON.parse(storedCustomerRaw)
        : null;
      const localCustomerId = storedCustomer?.customerId || storedCustomer?.id;
      if (localCustomerId) resolvedCustomerId = localCustomerId;
    } catch {}
  }

  // 3) Derive from logged-in user via onboarding service
  if (!resolvedCustomerId) {
    try {
      const storedUserRaw =
        typeof window !== "undefined" ? localStorage.getItem("userData") : null;
      const storedUser = storedUserRaw ? JSON.parse(storedUserRaw) : null;
      const userId = storedUser?.userId;
      if (userId) {
        const customerResp = await OnboardingService.getCustomerByUserId(
          Number(userId),
          { skipErrorCapture: true }
        );
        const got = customerResp?.data;
        const derivedId = got?.customerId || got?.id;
        if (derivedId) {
          resolvedCustomerId = derivedId;
          try {
            localStorage.setItem("customerData", JSON.stringify(got));
          } catch {}
        }
      }
    } catch {}
  }

  return resolvedCustomerId;
}
